import {
  GET_FILTERD_RENTAL,
  GET_MINE_RENTAL_ORDER,
  GET_RENTAL,
  GET_RENTAL_BY_ID,
  GET_RENTAL_MINE,
  GET_RENTAL_ORDER,
  GET_RENTAL_REQUEST_BY_ID,
} from "../constants/index";

export const rental = (
  state = {
    getrentallist: [],
    getrentalbyid: {},
    getminerentallist: [],
    getfilterdrental: {},
    minerentalorderlist: {},
    getrentalrequestbyid: {},
  },
  action
) => {
  switch (action.type) {
    case GET_RENTAL:
      return { ...state, getrentallist: action.getrentallist };
    case GET_RENTAL_MINE:
      return { ...state, getminerentallist: action.getminerentallist };
    case GET_RENTAL_BY_ID:
      return { ...state, getrentalbyid: action.getrentalbyid };
    case GET_FILTERD_RENTAL:
      return { ...state, getfilterdrental: action.getfilterdrental };
    case GET_RENTAL_ORDER:
      return {
        ...state,
        rentalorderlist: action.rentalorderlist,
      };
    case GET_MINE_RENTAL_ORDER:
      return {
        ...state,
        minerentalorderlist: action.minerentalorderlist,
      };
      case GET_RENTAL_REQUEST_BY_ID:
        return {
          ...state,
          getrentalrequestbyid: action.getrentalrequestbyid,
        };
    default:
      return state;
  }
};
